// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"1fee23af","163":"b05dc4ec","191":"8888580d","829":"f9d55407"}[chunkId] + ".chunk.css";
};